export default "__VITE_ASSET__DJQ0ExCL__"